import React, { useState } from 'react';
import { Paperclip, DownloadSimple } from '@phosphor-icons/react';

// Extract ![label](url.png|...) markdown image tokens from a comment body and expose them as a
// compact paperclip indicator. QA/reviewers can one-click download individual screenshots without
// scrolling the rendered comment for each attachment.
function extractAttachments(content) {
  const out = [];
  const re = /!\[([^\]]*)\]\((\S+?)\)/g;
  let m;
  while ((m = re.exec(content || ''))) {
    if (/\.(png|jpe?g|gif|webp|svg)(\?.*)?$/i.test(m[2])) {
      out.push({ name: m[1] || 'screenshot', url: m[2] });
    }
  }
  return out;
}

export default function CommentAttachments({ content }) {
  const [open, setOpen] = useState(false);
  const items = extractAttachments(content);
  if (!items.length) return null;
  return (
    <div className="mt-2 relative inline-block" data-testid="comment-attachments">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="inline-flex items-center gap-1 text-[10px] text-zinc-500 hover:text-blue-600 bg-zinc-50 hover:bg-blue-50 border border-zinc-200 rounded-full px-2 py-0.5 transition-colors"
        title={`${items.length} image attachment${items.length > 1 ? 's' : ''}`}
      >
        <Paperclip size={11} />
        {items.length} attachment{items.length > 1 ? 's' : ''}
      </button>
      {open && (
        <div className="absolute z-20 left-0 mt-1 w-64 bg-white rounded-lg shadow-lg border border-zinc-200 p-2 space-y-1" data-testid="comment-attachments-list">
          {items.map((it, i) => (
            <a
              key={i}
              href={it.url}
              target="_blank"
              rel="noreferrer"
              download
              className="flex items-center gap-2 px-2 py-1.5 rounded hover:bg-zinc-50 transition-colors text-[11px] text-zinc-700 group"
            >
              <img src={it.url} alt="" className="w-8 h-8 object-cover rounded border border-zinc-100 flex-shrink-0" />
              <span className="flex-1 min-w-0 truncate">{it.name}</span>
              <DownloadSimple size={12} className="text-zinc-400 group-hover:text-blue-600 flex-shrink-0" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
